import * as React from "react";

function UpArrowControlSet(props) {
  return (
    <svg className={"upArrow"} xmlns="http://www.w3.org/2000/svg" width="10.034" height="5.724" viewBox="0 0 10.034 5.724" style={{...props.styling, transform:"rotate(180deg)", margin:"0px",}}><defs>
    {/* <style>.a{fill:none;stroke:#202020;stroke-miterlimit:10;}</style> */}
    </defs>
    <path className="a" fill="none" stroke={props.color||"#202020"} strokeMiterlimit="10" d="M0,9.327,4.663,4.664,0,0" transform="translate(9.681 0.354) rotate(90)"/>
    </svg>
  );
}

export default UpArrowControlSet;
